export const itemLocalstorage = {
    partnerCode:"partnerCode",
    paymentId:"paymentId",
    frSystm:'frSystm',
    dataPayment:"dataPayment",
    callbackURL:"callbackURL"
}